export default "__VITE_ASSET__DHaFXdRc__"